import { rappiBaseUrl, breadcrumbs, NoPhotoUrl, modules, rumAuth } from './environment.global';
export const api = 'api/cauth/revenue/access/proxy';
export const environment = {
  rumAuth,
  rappiBaseUrl,
  breadcrumbs,
  NoPhotoUrl,
  modules,
  production: false,
  environment: 'LOCAL',
  urlAuth: '/access/auth',
  urlAlert: '/mtz/notifications',
  urlDeeplinks: '//deeplinks-dev-dot-rappi-202719.appspot.com/api/v1',
  urlStockout: 'https://test-api.rappione.com/stockout',
  urlStockout_v2: 'https://dev-api.rappione.com/stockout',
  urlFileManagement: '/file/manager',
  urlSamplingBase: '/sampling',
  urlMissionsCommanderBase: '/missions/commander/',
  urlMissionsInventoryBase: '/missions/inventory/',
  baseUrl: 'https://microservices.dev.rappi.com/api/one',
  urlRevenue: '/access/manager',
  urlNotifications: '/revenue/notifications',
  urlImage: {
    AR: 'https://images.rappi.com.ar/products/',
    BR: 'https://images.rappi.com.br/products/',
    CL: 'https://images.rappi.cl/products/',
    CO: 'https://images.rappi.com/products/',
    MX: 'https://images.rappi.com.mx/products/',
    PE: 'https://images.rappi.pe/products/',
    UY: 'https://images.rappi.com.uy/products/',
    CR: 'https://images.rappi.co.cr/products/',
    DEV: 'https://images.rappi.com/products/'
  },
  urlProductReport: 'https://support-one.rappi.com',
  urlTradeMfeSourceRoot: 'http://localhost:5001',
  urlSenseMfeSourceRoot: 'http://localhost:5002',
  urlAnalyzeMfeSourceRoot: 'http://localhost:5003',
  urlMtzSamplingMgmtMfeSourceRoot: 'http://localhost:5005',
  urlSamplingExtMfeSourceRoot: 'http://localhost:5000',
  urlMasterDataMfeSourceRoot: 'http://localhost:5002',
  urlAudiencesSourceRoot: 'http://localhost:5005',
  urlAdsMfeSourceRoot: 'http://localhost:5000',
  urlSettingsAmplifyMfeSourceRoot: 'http://localhost:5005',
  urlSettingsRequestHubMfeSourceRoot: 'http://localhost:5007',
  urlDeeplinksMfeSourceRoot: 'http://localhost:5010',
  urlAmplifyMfeSourceRoot: 'http://localhost:5011',
  urlCatalogClientMfeSourceRoot: 'http://localhost:5006',
  urlMtzRequestHubMfeSourceRoot: 'http://localhost:5005',
  urlMtzReportsMfeSourceRoot: 'http://localhost:5005',
  urlPerformancePredictorMfeSourceRoot: 'http://localhost:5002',
  urlGatewayInt: '/adv-bbr-gateway-int',
  urlHomeDashboardMfeSourceRoot: 'http://localhost:5018',
  urlBbrPbiManagerMfeSourceRoot: 'http://localhost:5007',

  roles: {
    super: 'superadmin',
    maker: 'adminmaker',
    agency: 'agency',
    user: 'userbrand'
  },
  basePaths: [
    {
      code: 'DEV',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'CO',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'AR',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'BR',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'CL',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'MX',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'PE',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'UY',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'EC',
      url: `https://microservices.dev.rappi.com/${api}`
    },
    {
      code: 'CR',
      url: `https://microservices.dev.rappi.com/${api}`
    }
  ],
  route_hash: true,
  firebase: {
    apiKey: 'AIzaSyC_Vfp6OXuhcXp3o-APJBm1pbfe9XEzp_g',
    authDomain: 'brandsbyrappidev-fcec0.firebaseapp.com',
    databaseURL: 'https://brandsbyrappidev-fcec0-default-rtdb.firebaseio.com',
    projectId: 'brandsbyrappidev-fcec0',
    storageBucket: 'brandsbyrappidev-fcec0.appspot.com',
    messagingSenderId: '146194732805',
    appId: '1:146194732805:web:3129bedd72d7417959896c',
    measurementId: 'G-TSH8ENHGMF'
  }
};
